import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const MessagesListContainer = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 20px;
  margin: 0;
  padding: 0;
`;

export const MessageItem = styled.li`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export const MessageDetailsContainer = styled.div`
  display: flex;
  column-gap: 5px;
  align-items: center;
`;

export const MessageAuthor = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  margin: 0px;
`;

export const MessageDetails = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0px;
`;

export const MessageBody = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin: 0px;
`;
